import { CraftJsonDto } from '@builder4/shared/dto/craft';
import type { RootState } from '@/store/store';
import { createSelector } from '@reduxjs/toolkit';

// Select the entire pages state
export const selectPagesState = (state: RootState) => state.pages;

// Select the pages list
export const selectPagesList = (state: RootState) => state.pages.list;

// Select loading state
export const selectPagesLoading = (state: RootState) => state.pages.loading;

// Select error state
export const selectPagesError = (state: RootState) => state.pages.error;

// Select current path
export const selectSelectedPath = (state: RootState) => state.pages.selectedPath;

// Select specific loading states
export const selectIsPagesLoading = (state: RootState) => state.pages.loading === 'loading';
export const selectIsPagesSucceeded = (state: RootState) => state.pages.loading === 'succeeded';
export const selectIsPagesFailed = (state: RootState) => state.pages.loading === 'failed';
export const selectIsPagesIdle = (state: RootState) => state.pages.loading === 'idle';

// Select pages count
export const selectPagesCount = (state: RootState) => state.pages.list.length;

// Select page by ID
export const selectPageById = (state: RootState, pageId: string) =>
  state.pages.list.find((page) => page.id === pageId);

//page selectors
export const selectCurrentPage = createSelector(
  [(state: RootState) => state.pages.currentPage],
  (currentPage) => {
    if (!currentPage) return null;
    return {
      ...currentPage,
      craftJson: CraftJsonDto.fromPage(currentPage.craftJson),
    };
  },
);
export const selectCurrentPageId = (state: RootState) => state.pages.currentPageId;
export const selectCreatePageLoading = (state: RootState) => state.pages.createPageLoading;
export const selectReadPageLoading = (state: RootState) => state.pages.readPageLoading;
export const selectUpdatePageLoading = (state: RootState) => state.pages.updatePageLoading;
export const selectPublishStatus = (state: RootState) => state.pages.publishing;

export const selectPublishedUrl = (state: RootState): string => {
  const { currentPage } = state.pages;
  if (!currentPage) return '';
  if (currentPage.publishedVersionId && currentPage.domain && currentPage.path) {
    return `https://${currentPage.domain}/${currentPage.path}`;
  }
  return '';
};

export const selectPageNotFound = (state: RootState) => state.pages.pageNotFound;

export const selectPageInvalid = (state: RootState) => state.pages.pageInvalid;

export const selectConsecutiveSaveFailures = (state: RootState) =>
  state.pages.consecutiveSaveFailures;

export const selectUnpublishing = (state: RootState) => state.pages.unpublishing;
